import type { StaticImageData } from "next/image";
import stocksGif from "@/app/assets/images/icm-3.0/stocks.gif";
// import digitalGoldGif from "@/app/assets/images/icm-3.0/digital-gold.gif";
// import mutualFundsGif from "@/app/assets/images/icm-3.0/mutual-funds.gif";
// import ipoGif from "@/app/assets/images/icm-3.0/ipo.gif";
// import globalStocksGif from "@/app/assets/images/icm-3.0/global-stocks.gif";
// import fdGif from "@/app/assets/images/icm-3.0/fd.gif";

/** Served from /public — Turbopack cannot import .mp4 as modules. */
const SAVE_BROKERAGE_VIDEO = "/videos/save-brokerage.mp4";
const YIELD_ENGINE_VIDEO = "/videos/yield-engine.mp4";
const GOLD_REWARDS_VIDEO = "/videos/gold-rewards.mp4";
const MUTUAL_FUNDS_VIDEO = "/videos/mutual-funds.mp4";

export type WhyChooseCategoryId =
    | "stocks"
    | "digital-gold"
    | "mutual-funds"
    | "ipo"
    | "global-stocks"
    | "fixed-deposits";

export type WhyChooseMedia =
    | { type: "image"; src: StaticImageData }
    | { type: "video"; src: string };

export type WhyChooseFeature = {
    id: string;
    label: string;
    media: WhyChooseMedia;
};

export type WhyChooseCategory = {
    id: WhyChooseCategoryId;
    /** Single-line label (mobile tabs + most desktop rows) */
    label: string;
    /** Desktop multi-line label when needed */
    labelLines?: readonly string[];
    /** Nested features shown when the category is active */
    features?: readonly WhyChooseFeature[];
    /** Media when the category has no nested features */
    media: WhyChooseMedia;
};

export function isWhyChooseVideo(
    media: WhyChooseMedia,
): media is { type: "video"; src: string } {
    return media.type === "video";
}

/**
 * Why Choose Us — Figma web 5092:31326 / mobile 2541:30594
 * Feature copy from product brief; media uses category GIFs until per-item assets land.
 */
export const WHY_CHOOSE_CATEGORIES: readonly WhyChooseCategory[] = [
    {
        id: "stocks",
        label: "Stocks",
        media: { type: "image", src: stocksGif },
        features: [
            {
                id: "stocks-save-brokerage",
                label: "Save Brokerage",
                media: { type: "video", src: SAVE_BROKERAGE_VIDEO },
            },
            {
                id: "stocks-yield-engine",
                label: "Yield Engine",
                media: { type: "video", src: YIELD_ENGINE_VIDEO },
            },
            // {
            //     id: "stocks-mtfs",
            //     label: "MTFs",
            //     media: { type: "image", src: stocksGif },
            // },
            // {
            //     id: "stocks-scalper",
            //     label: "Scalper",
            //     media: { type: "image", src: stocksGif },
            // },
            // {
            //     id: "stocks-algo-trading",
            //     label: "Algo Trading",
            //     media: { type: "image", src: stocksGif },
            // },
        ],
    },
    {
        id: "digital-gold",
        label: "Digital Gold & Silver",
        labelLines: ["Digital Gold", "& Silver"],
        media: { type: "video", src: GOLD_REWARDS_VIDEO },
        // features: [
        //     {
        //         id: "dg-rewards",
        //         label: "Rewards",
        //         media: { type: "video", src: GOLD_REWARDS_VIDEO },
        //     },
        //     {
        //         id: "dg-coin-delivery",
        //         label: "Coin Delivery",
        //         media: { type: "video", src: GOLD_REWARDS_VIDEO },
        //     },
        //     {
        //         id: "dg-sips",
        //         label: "SIPs",
        //         media: { type: "video", src: GOLD_REWARDS_VIDEO },
        //     },
        //     {
        //         id: "dg-one-time",
        //         label: "One-Time",
        //         media: { type: "video", src: GOLD_REWARDS_VIDEO },
        //     },
        // ],
    },
    {
        id: "mutual-funds",
        label: "Mutual Funds",
        media: { type: "video", src: MUTUAL_FUNDS_VIDEO },
        // features: [
        //     {
        //         id: "mf-sips",
        //         label: "SIPs",
        //         media: { type: "video", src: MUTUAL_FUNDS_VIDEO },
        //     },
        //     {
        //         id: "mf-one-time",
        //         label: "One-Time",
        //         media: { type: "video", src: MUTUAL_FUNDS_VIDEO },
        //     },
        //     {
        //         id: "mf-nfo",
        //         label: "NFO",
        //         media: { type: "video", src: MUTUAL_FUNDS_VIDEO },
        //     },
        // ],
    },
    // { id: "ipo", label: "IPO", media: { type: "image", src: ipoGif } },
    // {
    //     id: "global-stocks",
    //     label: "Global Stocks",
    //     media: { type: "image", src: globalStocksGif },
    // },
    // {
    //     id: "fixed-deposits",
    //     label: "Fixed Deposits",
    //     media: { type: "image", src: fdGif },
    // },
] as const;
